const apiPath = Object.freeze({
  loginUser: "/v1/service-provider/login",
  orderList: "/v1/service-provider/order-list",
  forgetPassword: "/v1/service-provider/forgot-password",
  resetPassword: "/v1/service-provider/reset-password",
  changePassword: "/v1/service-provider/change-password",
  alltransactionList: "/v1/service-provider/transaction",
  getDashboardDetails: "/v1/service-provider/dashboard",
  getDriverList: '/v1/service-provider/driver',
  generatePeoviderPreSignUrl: '/v1/service-provider/generatePreSignedUrl',
  register: '/v1/service-provider/register',
  getMasterCategory: '/v1/service-provider/master-data',
  getProviderNotification: '/v1/service-provider/notifications',
  getUserProfileData: '/v1/service-provider',
  addDriver: '/v1/service-provider/driver/add',
  editDriver: '/v1/service-provider/driver/update',
  getProfileData: '/v1/service-provider',
  deleteNotification: '/v1/service-provider/delete-notifications',
  getEarning: '/v1/service-provider/earning',
  getRequestList: "/v1/service-provider/service",
  getFeedbackList: '/v1/service-provider/feedback',
  orderDetails: "/v1/service-provider/order-list/details",
  updateAvailability: "/v1/service-provider/update-availability",
  getZendeskToken: 'v1/service-provider/zendesk-account-token',
  getRequestDetailsList: "/v1/service-provider/service/details",
  getRefreshToken: '/v1/service-provider/refresh-token',
  getDriverAvailabilityCalendar: '/v1/service-provider/driver/get-all-driver-availability',
  getDriverAvailabilityCalendarDateWise: '/v1/service-provider/driver/get-driver-availability-date-wise',
  getVehicleList: '/v1/service-provider/vehicle',
  addVehicle: '/v1/service-provider/vehicle/add-vehicle',
  editVehicle: '/v1/service-provider/vehicle/edit-vehicle',
  getVehicleDriverList: '/v1/service-provider/vehicle/driver-list',
  adminServiceList: '/v1/service-provider/service/admin-service-list',
  getServiceDetails:'/v1/service-provider/service/sp-service-details',
  editSPServicePrice:'/v1/service-provider/service/edit-service',
  servicePriceChangeStatus:'/v1/service-provider/service',
  announcementList:'/v1/service-provider/announcement-list'
});

export default apiPath;
